import classNames from "classnames";

const UploadsSection = ({
  invoiceFile,
  invoiceError,
  isDragOver,
  onDrop,
  onDragOver,
  onDragLeave,
  onInvoiceInputChange,

  videoRef,
  isRecording,
  hasRecordedVideo,
  recordedVideoUrl,
  videoError,
  cameraError,
  cameraActive,
  handleRecordClick,
  handleVideoUpload,
}) => {
  return (
    <section className="grid-2 uploads">
      {/* Invoice Copy */}
      <div className="card">
        <h2 className="card__title">
          <span className="section-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
          </span>
          Invoice Copy
        </h2>

        <div
          className={classNames("dropzone", { "drag-over": isDragOver })}
          onClick={() => document.getElementById("invoiceInput").click()}
          onDrop={onDrop}
          onDragOver={onDragOver}
          onDragLeave={onDragLeave}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M7 16a4 4 0 01-1-7.874A5 5 0 0115.9 6.1 4.5 4.5 0 0117.5 15H16m-9 5l4-4m0 0l4 4m-4-4v9"
            />
          </svg>
          <p className={classNames("dropzone__text", { done: !!invoiceFile })}>
            {invoiceFile
              ? `✓ ${invoiceFile.name}`
              : "Drag & drop invoice or click to browse"}
          </p>
          <p className="dropzone__hint">PDF, JPG, PNG up to 10MB</p>
          <button
            type="button"
            className="browse-btn"
            onClick={(e) => {
              e.stopPropagation();
              document.getElementById("invoiceInput").click();
            }}
          >
            Browse Files
          </button>
          <input
            type="file"
            id="invoiceInput"
            className="hidden-input"
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={onInvoiceInputChange}
          />
        </div>
        <div className="err-msg">{invoiceError}</div>
      </div>

      {/* Product Video */}
      <div className="card">
        <h2 className="card__title">
          <span className="section-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 10l4.55-2.28A1 1 0 0121 8.6v6.8a1 1 0 01-1.45.9L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
              />
            </svg>
          </span>
          Product Video
        </h2>

        <div className="camera-box">
          <video
            ref={videoRef}
            className={classNames("camera-video", { hidden: !cameraActive })}
            autoPlay
            playsInline
            muted
          />
          <video
            className={classNames("camera-video", {
              hidden: !hasRecordedVideo,
            })}
            src={recordedVideoUrl || undefined}
            controls
            playsInline
          />
          {isRecording && (
            <div className="rec-indicator">
              <span className="rec-dot" /> REC
            </div>
          )}
          {!cameraActive && !hasRecordedVideo && (
            <div className="camera-placeholder">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 10l4.55-2.28A1 1 0 0121 8.6v6.8a1 1 0 01-1.45.9L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                />
                <line x1="3" y1="3" x2="21" y2="21" strokeLinecap="round" />
              </svg>
              <p>Camera access required</p>
            </div>
          )}
        </div>

        <div className="camera-actions">
          <button
            type="button"
            className="btn btn--primary"
            onClick={handleRecordClick}
          >
            {isRecording ? (
              <>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <rect
                    x="7"
                    y="7"
                    width="10"
                    height="10"
                    rx="1.5"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Stop Recording
              </>
            ) : hasRecordedVideo ? (
              <>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  />
                </svg>
                Record Again
              </>
            ) : (
              <>
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 10l4.55-2.28A1 1 0 0121 8.6v6.8a1 1 0 01-1.45.9L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                  />
                </svg>
                Record Video
              </>
            )}
          </button>
          <button
            type="button"
            className="btn btn--dark"
            onClick={() => document.getElementById("videoInput").click()}
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1M12 12V3m0 0L8 7m4-4l4 4"
              />
            </svg>
            Upload
          </button>
          <input
            type="file"
            id="videoInput"
            className="hidden-input"
            accept="video/*"
            onChange={handleVideoUpload}
          />
        </div>
        <p className="err-msg">{cameraError || videoError}</p>
      </div>
    </section>
  );
};

export default UploadsSection;
